@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.preview-email-branding-modal {
  width: 1200px;
}

.modal-body {
  background-color: @settings-page--branding-modal--background-color;

  .preview {
    background-color: @settings-page--branding-modal--background-color;

    &:global(.brand-editor_preview) {
      height: calc(100vh - 200px);
    }

    :global(.brand-editor_preview-tabs) {
      display: flex;
      width: 100%;
      justify-content: center;
      margin: @space-16 0 @space-32;

      :global(.brand-editor_active-tab) {
        text-decoration: underline;
        font-weight: 600;
      }

      :global(.brand-editor_preview-tab-mobile),
      :global(.brand-editor_preview-tab-desktop),
      :global(.brand-editor_preview-tab-tablet) {
        margin-right: @space-8;
        color: @settings-page--branding-modal-preview--text-color;

        &:hover {
          font-weight: 500;
          text-decoration: none;
        }

        &:focus {
          background-color: @settings-page--branding-modal--background-color;
          text-decoration: underline;
          font-weight: 600;
        }
      }
    }
  }
}
